/*
 * Share Review Viewer Page Template
 */
import type {
  PanelArea,
  PanelsBreakpointTemplate,
  PanelsTemplate,
  ShareReviewViewerPageArea,
} from '../types';
import { DETAILS_DEFAULT_WIDTH, DETAILS_MIN_WIDTH } from './constants';

/**
 * Base template (Mobile +)
 */
export function baseTemplate(
  visible: Array<PanelArea>
): PanelsBreakpointTemplate {
  return {
    areas: [['viewer'], ['details']],
    resizers: {
      viewer: 'bottom',
    },
    columns: [
      /* Viewer Panel */
      {
        key: 'viewer',
        defaultMin: 300,
        defaultSize: '1fr',
        isToggleable: false,
        showing: true,
      },
    ],
    rows: [
      /** Main Area */
      {
        key: 'viewer',
        defaultMin: 200,
        defaultSize: '1fr',
        isToggleable: false,
        showing: true,
      },

      /* Details Panel */
      {
        key: 'details',
        defaultMin: 200,
        defaultSize: DETAILS_DEFAULT_WIDTH,
        defaultMax: 600,
        isToggleable: true,
        showing: visible.includes('details'),
      },
    ],
  };
}

/**
 * Medium template
 */
export const mediumTemplate = (
  visible: Array<PanelArea>,
  isFlex = true
): PanelsBreakpointTemplate => {
  return {
    areas: [['viewer', 'details']],
    resizers: {
      viewer: 'right',
    },
    columns: [
      /* Viewer Panel */
      {
        key: 'viewer',
        defaultMin: 300,
        defaultSize: '1fr',
        isToggleable: false,
        showing: true,
      },

      /* Details Panel */
      {
        key: 'details',
        defaultMin: DETAILS_MIN_WIDTH,
        defaultSize: DETAILS_DEFAULT_WIDTH,
        defaultMax: 600,
        isToggleable: true,
        showing: visible.includes('details'),
        isFlex,
      },
    ],
    rows: [
      /** Main Area */
      {
        key: 'defaultRow',
        defaultMin: 200,
        defaultSize: '1fr',
        isToggleable: false,
      },
    ],
  };
};

/**
 * Large template
 */
export const largeTemplate = (
  visible: Array<PanelArea>
): PanelsBreakpointTemplate => {
  return mediumTemplate(visible, false);
};

export function getPanelState(visible: Array<PanelArea>): PanelsTemplate {
  return {
    base: baseTemplate(visible),
    tablet: mediumTemplate(visible),
    desktop: largeTemplate(visible),
    visible,
  };
}

export const getDefaultVisiblePanels = (): Array<ShareReviewViewerPageArea> => {
  return ['viewer'];
};

// Because this page encapsulates three "pages", each has a different layout default
export const getDefaultPanelState = (): PanelsTemplate => {
  return getPanelState(getDefaultVisiblePanels());
};
